import DefaultLayout from '##/Default';
import List from './List';


const routes = [

    {
        path: '/titles/:title_id/eval-questions',
        exact: true,
        layout: DefaultLayout,
        component: List,
        auth: true,
        title: 'Eval Questions'
    }
];

export default routes;
